import React from 'react';
import FilesList from '../containers/FilesList';

export default function Software() {
  return <FilesList rootDir='software' title="Software Downloads" />
}
